module.exports = __webpack_public_path__ + "img/banner.a21bff85.png";